import type { BalanceModel } from "../index";
import { BalanceRepoWs, type ChanelActionType } from "@trading/infrastructure";

export default class BalanceService {
  constructor(private repo: BalanceRepoWs) {
  }

  async subscribeToBalancesUpdate(
    actionName: ChanelActionType,
    cb: (order: BalanceModel) => void
  ): Promise<undefined | CallableFunction> {
    return await this.repo?.subscribeToChannelsAction(actionName, cb)
  }

  unsubscribe(): void {
    this.repo.unsubscribeToChannel()
  }
}